"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCustomerQuery = exports.BaseCustomerPromotion = exports.BaseCustomerUpdate = exports.BaseCustomerCreate = exports.BaseCustomer = exports.AccountRep = exports.CustomerInvoicePdfDisplayOptions = exports.DoNotServiceFlag = exports.DoNotServiceFlags = exports.ExperienceDescriptor = exports.InvoiceIssueTerm = exports.InvoiceIssueTermLabels = exports.InvoiceIssueTerms = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const address_transport_1 = require("./address-transport");
const base_customer_contact_1 = require("./base-customer-contact");
const business_category_1 = require("./business-category");
const customer_type_1 = require("./customer-type");
const service_location_transport_1 = require("./service-location-transport");
const wayste_customer_document_transport_1 = require("./wayste-customer-document-transport");
exports.InvoiceIssueTerms = ['IMMEDIATE', 'MANUAL'];
exports.InvoiceIssueTermLabels = {
    IMMEDIATE: 'Immediate',
    MANUAL: 'Manual',
};
exports.InvoiceIssueTerm = typebox_1.Type.Union(exports.InvoiceIssueTerms.map((term) => typebox_1.Type.Literal(term)));
exports.ExperienceDescriptor = typebox_1.Type.Union([
    typebox_1.Type.Literal('Positive'),
    typebox_1.Type.Literal('Negative'),
    typebox_1.Type.Literal('Neutral'),
]);
exports.DoNotServiceFlags = ['MANUAL', 'CREDIT_LIMIT', 'IN_COLLECTIONS'];
exports.DoNotServiceFlag = typebox_1.Type.Union(exports.DoNotServiceFlags.map((flag) => typebox_1.Type.Literal(flag)));
exports.CustomerInvoicePdfDisplayOptions = typebox_1.Type.Object({
    showServiceLocationTotals: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    showOrderSubtotals: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    showChargeAmounts: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.AccountRep = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.BaseCustomer = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String(),
    customerNumber: typebox_1.Type.Number(),
    billingAddress: address_transport_1.AddressTransport,
    type: customer_type_1.CustomerType,
    businessCategory: typebox_1.Type.Optional(business_category_1.BusinessCategory),
    // Currently Sourgum Only
    accountCredit: typebox_1.Type.Integer(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()), // How can we get rid of this?
    invoiceIssueTerm: exports.InvoiceIssueTerm,
    taxExempt: typebox_1.Type.Boolean(),
    reviewed: typebox_1.Type.Boolean(),
    doNotServiceFlags: typebox_1.Type.Partial(typebox_1.Type.Record(exports.DoNotServiceFlag, typebox_1.Type.Boolean())),
    leadID: typebox_1.Type.Optional(typebox_1.Type.String()), // This is no longer going to work as it needs to be many leads to one customer
    files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    balanceLimit: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    balance: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    balanceLastUpdated: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    accountCreditLastUpdated: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    /**
     * @deprecated use accountRep instead
     */
    accountManagerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountManagerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * @deprecated use accountRep instead
     */
    accountRepID: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountRepName: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountExecutive: typebox_1.Type.Optional(exports.AccountRep),
    accountManager: typebox_1.Type.Optional(exports.AccountRep),
    motivation: typebox_1.Type.Optional(typebox_1.Type.String()),
    businessType: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    channel: typebox_1.Type.Optional(typebox_1.Type.String()), // Just made this optional, ensure nothing breaks
    companyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    displayName: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
    // Currently Wayste Only
    allowWaysteDashboardAccess: typebox_1.Type.Boolean(),
    paymentTerm: typebox_1.Type.Integer({ minimum: 0 }),
    paymentMethod: common_1.PaymentMethod,
    allowedPaymentMethod: typebox_1.Type.Array(common_1.PaymentMethod), // This one is new
    documents: typebox_1.Type.Array(wayste_customer_document_transport_1.WaysteCustomerDocumentTransport),
    accessToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    // Not actually database columns
    contacts: typebox_1.Type.Array(base_customer_contact_1.BaseCustomerContact),
    serviceLocations: typebox_1.Type.Array(service_location_transport_1.ServiceLocationTransport),
    overallExperience: typebox_1.Type.Optional(exports.ExperienceDescriptor),
    // Do we still need these or can they be removed?
    doNotService: typebox_1.Type.Boolean(), // Not actually database columns replace by just using the flags?
    inCollections: typebox_1.Type.Boolean(), // Not actually database columns replace by just using the flags?
    // Wayste Only
    active: typebox_1.Type.Boolean(), // DB column
    /** Read-only. Updated automatically by the new-service-location queue consumer when an order is created. */
    lastOrderDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    invoicePdfDisplayOptions: typebox_1.Type.Optional(exports.CustomerInvoicePdfDisplayOptions),
});
exports.BaseCustomerCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BaseCustomer, [
        'id',
        'haulerID',
        'contacts',
        'customerNumber',
        'metadata',
        'invoiceIssueTerm',
        'balance',
        'balanceLastUpdated',
        'doNotServiceFlags',
        'accountCredit',
        'accountCreditLastUpdated',
        'lastOrderDate',
        'documents',
        'allowWaysteDashboardAccess',
        // These are optional on create
        'serviceLocations', // Only used in Wayste on create
        'taxExempt',
        'reviewed',
        'active',
        'invoicePdfDisplayOptions', // Only used in Wayste on update
    ]),
    typebox_1.Type.Object({
        invoiceIssueTerm: typebox_1.Type.Optional(exports.InvoiceIssueTerm),
        contacts: typebox_1.Type.Array(base_customer_contact_1.BaseCustomerContactCreate, { minItems: 1 }),
        /** Default to false */
        taxExempt: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        /** Default to false */
        reviewed: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        /** Default to true */
        active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
        paymentTerm: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        allowedPaymentMethod: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.PaymentMethod)),
    }),
]);
exports.BaseCustomerUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BaseCustomer, [
        'contacts',
        'customerNumber',
        'metadata',
        'invoiceIssueTerm',
        'balance',
        'balanceLastUpdated',
        'doNotServiceFlags',
        'balanceLimit',
        'accountCredit',
        'accountCreditLastUpdated',
        'lastOrderDate',
        'companyName',
        'accountManagerID',
        'accountManagerName',
        'accountRepID',
        'accountRepName',
        'motivation',
        'businessType',
        'businessCategory',
        'stripeID',
        'leadID',
        'overallExperience',
        'id',
        'serviceLocations',
    ]),
    typebox_1.Type.Object({
        invoiceIssueTerm: typebox_1.Type.Optional(exports.InvoiceIssueTerm),
        balanceLimit: (0, nullable_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.Integer())),
        lastClosedOrderDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
        companyName: (0, nullable_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String())),
        overallExperience: typebox_1.Type.Optional((0, nullable_1.Nullable)(exports.ExperienceDescriptor)),
        accountManagerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        accountManagerName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        accountRepID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        accountRepName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        motivation: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        businessType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        businessCategory: typebox_1.Type.Optional((0, nullable_1.Nullable)(business_category_1.BusinessCategory)),
        stripeID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        leadID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    }),
]));
exports.BaseCustomerPromotion = typebox_1.Type.Intersect([
    exports.BaseCustomerUpdate,
    typebox_1.Type.Object({
        serviceLocations: typebox_1.Type.Optional(typebox_1.Type.Array(service_location_transport_1.ServiceLocationTransport)),
    }),
]);
const sortByKey = typebox_1.Type.Union([
    typebox_1.Type.Literal('id'),
    typebox_1.Type.Literal('customerNumber'),
    typebox_1.Type.Literal('companyName'),
    typebox_1.Type.Literal('channel'),
    typebox_1.Type.Literal('type'),
    typebox_1.Type.Literal('businessType'),
]);
const sortDirection = typebox_1.Type.Union([typebox_1.Type.Literal('ASC'), typebox_1.Type.Literal('DESC')]);
exports.BaseCustomerQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        ids: typebox_1.Type.Optional(typebox_1.Type.String()),
        email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        companyName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        displayName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        customerNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        channel: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        experience: typebox_1.Type.Optional((0, nullable_1.Nullable)(exports.ExperienceDescriptor)),
        taxExempt: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
        type: typebox_1.Type.Optional((0, nullable_1.Nullable)(customer_type_1.CustomerType)),
        businessType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        reviewed: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
        doNotService: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
        sortBy: typebox_1.Type.Optional(sortByKey),
        sortDirection: typebox_1.Type.Optional(sortDirection),
        createdByUserId: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        createdAt_gte: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        createdAt_lte: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        hasBalance: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
        accountManagerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    }),
]));
//# sourceMappingURL=base-customer.js.map